import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';

function Countdown() {
  const { t } = useTranslation();
  const weddingDate = new Date('2026-10-31T13:00:00');
  
  const calculateTimeLeft = () => {
    const difference = weddingDate - new Date();
    
    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
    
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="countdown-wrapper">
      <div className="countdown-title">{t('countdown.title')}</div>
      <div className="countdown-container">
        <div className="countdown-card">
          <div className="countdown-value">{timeLeft.days}</div>
          <div className="countdown-label">{timeLeft.days === 1 ? t('countdown.day') : t('countdown.days')}</div>
        </div>
        <div className="countdown-separator">:</div>
        <div className="countdown-card">
          <div className="countdown-value">{timeLeft.hours}</div>
          <div className="countdown-label">{timeLeft.hours === 1 ? t('countdown.hour') : t('countdown.hours')}</div>
        </div>
        <div className="countdown-separator">:</div>
        <div className="countdown-card">
          <div className="countdown-value">{timeLeft.minutes}</div>
          <div className="countdown-label">{timeLeft.minutes === 1 ? t('countdown.minute') : t('countdown.minutes')}</div>
        </div>
        <div className="countdown-separator">:</div>
        <div className="countdown-card">
          <div className="countdown-value">{timeLeft.seconds}</div>
          <div className="countdown-label">{timeLeft.seconds === 1 ? t('countdown.second') : t('countdown.seconds')}</div>
        </div>
      </div>
    </div>
  );
}

export default Countdown;
